import { Search, X } from "lucide-react";

export const matches = (q, ...fields) => {
  const s = q.trim().toLowerCase();
  return !s || fields.some((f) => (f || "").toLowerCase().includes(s));
};

export function SearchBox({ value, onChange, placeholder = "Search staff or agent…", testId = "search-input" }) {
  return (
    <div className="relative w-full sm:w-72">
      <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full h-10 pl-9 pr-9 rounded-lg border border-slate-200 bg-white text-sm focus:outline-none focus:border-teal-500 focus:ring-2 focus:ring-teal-100"
        data-testid={testId}
      />
      {value && (
        <button onClick={() => onChange("")} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-slate-400 hover:text-slate-700" data-testid={`${testId}-clear`}>
          <X size={14} />
        </button>
      )}
    </div>
  );
}
